import { useCallback, useEffect, useRef } from 'react';

import superExpressSound from 'static/sound/super-expresso-modal.mp3';

interface SuperExpressAudioReturn {
  playAudio: () => void;
  stopAudio: () => void;
}

declare global {
  interface Window {
    superExpressAudio?: HTMLAudioElement;
  }
}

export function useSuperExpressAudio(): SuperExpressAudioReturn {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const playAudio = useCallback((): void => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    const audio = new Audio(superExpressSound);
    audio.loop = true;
    audioRef.current = audio;

    audio.play();

    window.superExpressAudio = audio;
  }, []);

  const stopAudio = useCallback((): void => {
    const audio = audioRef.current || window.superExpressAudio;

    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      audioRef.current = null;
      window.superExpressAudio = undefined;
    }
  }, []);

  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, [stopAudio]);

  return { playAudio, stopAudio };
}
